var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sinenav-list"},_vm._l((_vm.list),function(item){return _c('SidenavItem',{key:item.name,attrs:{"item":item},on:{"active":_vm.active,"toggle":_vm.toggle}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }